var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5942 0H1.28659C0.798191 0 0.400391 0.3978 0.400391 0.8862V3.198C0.400391 3.6666 0.607391 4.1076 0.936191 4.3782L4.86739 8.2224V11.5242C4.86739 11.8254 5.01199 12.1116 5.25499 12.2904C5.41999 12.4122 5.61919 12.4758 5.82019 12.4758C5.91439 12.4758 6.00859 12.462 6.10099 12.4338L8.34499 11.739C8.74519 11.6148 9.01459 11.25 9.01459 10.83V8.223L12.9134 4.4082C13.2746 4.1082 13.481 3.6678 13.481 3.1986V0.8862C13.4804 0.3978 13.0826 0 12.5942 0ZM12.4004 3.198C12.4004 3.345 12.3362 3.483 12.1904 3.606L8.09659 7.6086C7.99219 7.71 7.93399 7.8492 7.93399 7.995V10.7346L5.94739 11.3496V7.995C5.94739 7.8498 5.88859 7.7106 5.78479 7.6086L1.65859 3.5766C1.54519 3.483 1.48039 3.345 1.48039 3.198V1.08H12.4004V3.198Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlk);
export default __webpack_public_path__ + "static/media/filter-blk.055e51f0800620a6c686170f1fde20bb.svg";
export { ForwardRef as ReactComponent };